import { filter } from 'lodash-es'
import { object } from 'yup'
import { elementTypeToRequiredSupport } from '../../utils/getProblematicElements'

export const verticalTransmitterSchema = object({
  verticalTransmissionGraph: object().test('is-exact-transmitters', function (value) {
    const verticalTransmissionGraph = value as unknown as VerticalTransmissionGraph | undefined
    const { selectedElement, selectedElementType } = this.options.context || {}

    const elementType: ElementTypes = selectedElementType
    if (!(elementType && elementType in elementTypeToRequiredSupport)) return true

    const requiredSupports = elementTypeToRequiredSupport[elementType]
    const verticalTransmitters = filter(verticalTransmissionGraph?.element_supports || [], [
      'element_guid',
      selectedElement,
    ])

    if (requiredSupports && verticalTransmitters.length !== requiredSupports) {
      return this.createError({
        message: `Es müssen ${requiredSupports} Auflager definiert sein`,
      })
    }

    return true
  }),
})
